<template>
    <simple-modal :show="show" @close="toggleModal()" overflow=""
                  :title="(this.action + ' ' + modelType) | titlecase">
        <div class="flex flex-col gap-10">
            <div class="flex flex-col gap-4 text-md">
                <span class="flex items-center font-medium">You are about to {{ action }} this {{ modelType }}, are you sure?</span>

                <div v-if="additionalText && archiving">
                    <!-- Separate span for background colours to work-->
                    <span :class="additionalTextClass"> {{ additionalText }}</span>
                </div>
            </div>

            <div class="flex justify-end items-center">
                <secondary-button :name="buttonName" @click.prevent="executeAction()"></secondary-button>
            </div>
        </div>
    </simple-modal>
</template>

<script>
export default {
    name: "ArchiveAndUnarchiveModal",

    props: {
        show: {
            required: true,
            type: Boolean,
        },
        modelId: {
            required: true,
            type: Number,
        },
        modelType: {
            required: true,
            type: String,
        },
        urlOverride: {
            required: false,
            type: String,
            description: "When the model type is not enough to satisfy to archive and unarchive URL"
        },
        archiving: {
            required: true,
            Description: "Whether we are archiving or unarchiving the model"
        },
        additionalText: {
            required: false,
            type: String,
            description: "Any additional text or notes to add below the main text",
            default: "",
        },
        additionalTextClass: {
            required: false,
            type: String,
            description: "Tailwind styling for additionalText",
            default: "text-gray-400",
        },
    },

    data () {
        return {
            form: new AppForm({}),
        };
    },

    computed: {
        action () {
            return this.archiving ? "archive" : "unarchive";
        },

        buttonName () {
            if (this.archiving) {
                return this.form.busy ? "Archiving..." : "Archive";
            } else {
                return this.form.busy ? "Unarchive..." : "Unarchive";
            }
        }
    },

    mounted () {
        if (this.urlOverride) {
            this.url = `/${this.urlOverride}/${this.modelId}/${this.action}`;
        } else {
            this.url = `/${this.modelType}s/${this.modelId}/${this.action}`;
        }
    },

    methods: {
        toggleModal () {
            this.$emit("close");
        },

        executeAction () {
            App.patch(this.url, this.form)
            .then(response => {
                toastr.success(response);
                this.$emit("actioned", this.archiving);
                this.toggleModal();
            })
            .catch(error => {
                toastr.error(`Could not ${this.action} ${this.modelType}` + ". Error: " + error.message);
            });
        },
    },
};
</script>